<template>
  <div class="flex justify-between items-start border-1.5 rounded-xl p-4 gap-x-3 cursor-pointer"
    :class="geolocation?.deliveryAddress?.id === data.id ? 'border-primary-500 bg-primary-50' : 'border-gray-200'"  @click="clickAction">
    <div class="flex flex-col gap-y-1">
      <div class="flex items-center gap-x-2">
        <p class="font-medium text-sm">{{ data.contact.name }}, {{ data.area_code }}</p>
        <UBadge variant="soft" size="xs" class="bg-primary-50 text-primary-600 text-2xs font-medium capitalize"
          v-if="data.label">{{ data.label }}</UBadge>
      </div>
      <p class="text-gray-500 text-sm">{{ address }}</p>
    </div>
    <div class="flex items-center flex-none gap-x-3">
      <UIcon name="i-lucide-pencil-line"
        class="size-5 text-primary-500 cursor-pointer hover:text-primary-600 transition"
        @click.stop="editAddress(data)" />
      <UIcon name="i-heroicons-trash" class="size-6 text-primary-500" @click.stop="openDeletePopup(data.id)" />
    </div>
  </div>

  <V2Overlay v-model="isDeleteOpen" container-class="px-4">
    <V2DeletepopupComponent @confirm="confirmDelete" @close="isDeleteOpen = false" />
  </V2Overlay>

</template>

<script setup lang="ts">
import { GoogleAnalytics } from '~/google_analytics/events';
import { EventParameter } from '~/google_analytics/events.enum';
const checkout = useCheckout(); // ensure added
const cart = useCart();
const route = useRoute();
const geolocation = useGeoLocation();
const addressStore = useUserAddressStore();
const props = defineProps({
  data: { type: Object, default: () => ({}) }
});
const emit = defineEmits(['apply', 'reload']);

const address = computed(() => {
  const fields = ['door', 'building', 'locality', 'city', 'state'];
  const addressArray = fields.map((k: any) => props.data[k] || '').filter((v: string) => v && v.trim() !== '');
  return addressArray.join(', ');
});

const clickAction = () => {

  GoogleAnalytics.address({
    [EventParameter.ACTION]: 'select_saved_address',
    [EventParameter.STATUS]: 'selected',
    [EventParameter.ERROR_MESSAGE]: 'none',
  });
  emit('apply', props.data);
};

const isDeleteOpen = ref(false);
const addressToDelete = ref<number | null>(null);

const openDeletePopup = (id: number) => {
  addressToDelete.value = id;
  GoogleAnalytics.cta({
    [EventParameter.ACTION]: 'delete_address',
    [EventParameter.STATUS]: 'initiated',
    [EventParameter.ERROR_MESSAGE]: 'none',
  });
  isDeleteOpen.value = true;
};

const confirmDelete = async () => {
  try {

    if (!addressToDelete.value) return;
    await addressStore.deleteAddress(String(addressToDelete.value));

    const delivery = checkout.delivery_address;

    if (
      (delivery?.address_id && delivery.address_id === addressToDelete.value) ||
      (!delivery?.address_id && delivery?.formatted_address === props.data.formatted_address)
    ) {
      checkout.setDeliveryAddress(null);
    }
    isDeleteOpen.value = false;
    addressToDelete.value = null;
    await cart.fetchQuote();
    useCartToast({
      description: "Address deleted successfully",
      timeout: 1500,
    });
    GoogleAnalytics.address({
      [EventParameter.ACTION]: 'delete_address',
      [EventParameter.STATUS]: 'success',
      [EventParameter.ERROR_MESSAGE]: 'none',
     });

  } catch (err) {
    GoogleAnalytics.address({
      [EventParameter.ACTION]: 'delete_address',
      [EventParameter.STATUS]: 'delete_failed',
      [EventParameter.ERROR_MESSAGE]: (err && typeof err === 'object' && 'message' in err) ? err.message : String(err) || 'delete address failed',
     });
    console.error("Error in confirmDelete:", err);
  } finally {
  //   GoogleAnalytics.cta({
  //     [EventParameter.CTA_NAME]: 'delete_address'
    // });
  }
};

// CLICK → Edit Address
const editAddress = (addressObj: Record<string, any>) => {
  GoogleAnalytics.address({
    [EventParameter.ACTION]: 'edit_address',
    [EventParameter.STATUS]: 'initiated',
    [EventParameter.ERROR_MESSAGE]: 'none',
   });
  // GoogleAnalytics.cta({
  //   [EventParameter.CTA_NAME]: 'edit_address'
  // });
  sessionStorage.setItem("selectedEditAddress", JSON.stringify(addressObj));
  sessionStorage.setItem("lastPageBeforeMap", route.fullPath);
  navigateTo({
  path: '/map',
  query: {
    from: ['editAddress', 'cart']
  }
});
};

</script>